import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { pushOneClimate } from "../../../../middlewares/sysNavigation/SysNavigation";
import { useClimateContext } from "../../../../context/climate/ClimateContext";
import { Modal, Button, Search, Pagination } from "../../component/Component";
import { _PAGE_SIZE_ } from "../../../../middlewares/other/tools";

const addRoute = "/climate/add";
const editRoute = "/climate/edit";

const Overview = () => {
  let [climateList, setClimateList] = useState([]);
  const { climate, fetchClimates, count } = useClimateContext();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  useEffect(() => {
    if (!climate) fetchClimates(page, pageSize);
    setClimateList(climate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [climate]);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    let searchArray = [];
    if (climate !== null && climate !== undefined)
      climate.map((_climate_) => {
        if (_climate_.name.toString().toLowerCase().includes(key))
          return searchArray.push(_climate_);
        return true;
      });

    setClimateList(searchArray);
    if (key === "") setClimateList(climate);
  };

  return (
    <div className="h-full overflow-y-auto bg-gray-50 p-4 lg:p-6">
      <div className="mx-auto max-w-6xl">
        {/* Page header */}
        <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <span className="grid h-10 w-10 place-items-center rounded-xl bg-gray-900 text-white">
              {/* thermometer icon */}
              <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M14 14.76V5a4 4 0 10-8 0v9.76a6 6 0 108 0zM10 22a4 4 0 01-2-7.465V5a2 2 0 114 0v9.535A4 4 0 0110 22z" />
                <circle cx="10" cy="18" r="1.5" />
              </svg>
            </span>
            <div>
              <h1 className="text-lg font-semibold tracking-tight text-gray-900">Climate</h1>
              <p className="text-sm text-gray-600">Browse, add, and manage climate types.</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="hidden rounded-full bg-gray-100 px-3 py-1 text-xs font-semibold text-gray-700 sm:inline-flex">
              Total: {count ?? 0}
            </span>
            <Link to={addRoute}>
              <Button
                props={{
                  type: "button",
                  title: "Add Climate",
                  category: "default",
                  action: "add",
                  onClick: null,
                }}
              />
            </Link>
          </div>
        </div>

        {/* Search */}
        <div className="mb-4">
          <Search
            props={{
              title: "Climate",
              onChange: (e) => SearchList(e),
            }}
          />
        </div>

        {/* Table */}
        <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead className="sticky top-0 z-10 bg-gray-50/90 backdrop-blur">
                <tr className="text-gray-600">
                  <th className="w-2/3 border-b border-gray-200 px-4 py-3 font-semibold">
                    <div className="inline-flex items-center gap-2">
                      {/* label icon */}
                      <svg className="h-4 w-4 text-gray-400" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <path d="M21 11.5 12.5 3H6a3 3 0 0 0-3 3v6.5L11.5 21a2.121 2.121 0 0 0 3 0l6.5-6.5a2.121 2.121 0 0 0 0-3zM7.5 8A1.5 1.5 0 1 1 9 6.5 1.5 1.5 0 0 1 7.5 8z" />
                      </svg>
                      <span>Name</span>
                    </div>
                  </th>
                  <th className="w-1/3 border-b border-gray-200 px-4 py-3 text-right font-semibold">
                    <div className="inline-flex items-center gap-2">
                      {/* actions icon */}
                      <svg className="h-4 w-4 text-gray-400" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <circle cx="5" cy="12" r="2" />
                        <circle cx="12" cy="12" r="2" />
                        <circle cx="19" cy="12" r="2" />
                      </svg>
                      <span>Actions</span>
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100">
                {climate ? (
                  (() => {
                    if (!climateList) climateList = [...climate];
                    return climateList.map((_climate_) => (
                      <tr key={_climate_.climate_id} className="hover:bg-gray-50">
                        <td className="px-4 py-3 align-middle">
                          <div className="flex items-center gap-3">
                            <span className="grid h-8 w-8 place-items-center rounded-lg bg-gray-100 text-gray-700">
                              {/* cloud icon */}
                              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                <path d="M6 18a4 4 0 0 1 0-8 5 5 0 0 1 9.584-1.65A4.5 4.5 0 1 1 18.5 18H6z" />
                              </svg>
                            </span>
                            <span className="font-medium text-gray-900">{_climate_.name}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 align-middle">
                          <div className="flex justify-end">
                            <ActionButton props={_climate_} />
                          </div>
                        </td>
                      </tr>
                    ));
                  })()
                ) : (
                  <tr>
                    <td className="px-4 py-6 text-gray-400">Loading…</td>
                    <td className="px-4 py-6 text-right text-gray-400">Loading…</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        <div className="mt-4">
          <Pagination
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total_items={count}
            callbackFunction={(_page_, _pageSize_) => {
              fetchClimates(_page_, _pageSize_);
            }}
          />
        </div>
      </div>
    </div>
  );
};

/**
 *  @author Ntavigwa Bashombe
 */
const ActionButton = ({ props }) => {
  const { climate, updateClimateState, deleteClimate } = useClimateContext();
  const [showModal, setShowModal] = useState(false);

  const climate_id = props.climate_id;
  const climate_name = props.name;
  const _climate_ = props;

  const deleteOneClimateById = async (id) => {
    const response = await deleteClimate(id);
    if (response.data.status === 200) {
      if (climate) {
        const update = climate.filter((c) => c.climate_id !== id);
        updateClimateState(update);
        setShowModal(false);
      }
    }
  };

  return (
    <>
      <Modal
        props={{
          name: climate_name,
          showModal: showModal,
          setShowModal: () => setShowModal(false),
          delete: () => deleteOneClimateById(climate_id),
        }}
      />

      <div className="flex items-center gap-2">
        <Link to={editRoute}>
          <Button
            props={{
              type: "button",
              title: "Edit",
              category: "blue",
              action: "edit",
              onClick: () => {
                pushOneClimate(_climate_);
              },
            }}
          />
        </Link>
        <Button
          props={{
            type: "button",
            title: "Delete",
            category: "red",
            action: "delete",
            onClick: () => setShowModal(true),
          }}
        />
      </div>
    </>
  );
};

export default Overview;
